var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeftDoubleFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ri:arrow-left-double-fill"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3 12L10.9511 20L12.7624 18.1775L6.62264 12L12.7624 5.82246L10.9511 4L3 12ZM10.2376 12L18.1887 20L20 18.1775L13.8602 12L20 5.82246L18.1887 4L10.2376 12Z",
    fill: "#A3AED0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftDoubleFill);
export default __webpack_public_path__ + "static/media/arrow-left-double-fill.fd52ebeb724c6ec3bc01826f479355c4.svg";
export { ForwardRef as ReactComponent };